/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoMessengerSettings {
    'use strict';

    class AutoRepliesContoller {
        static $inject = [];

        public replies: Meevo.Model.IMeevoMessengerAutoReply[];
        public isEditingMessaging: boolean;
        public charLimit: number;

        constructor() { }
    }

    class AutoRepliesComponent implements angular.IComponentOptions {
        templateUrl = 'app/plugins/meevoMessengerSettings/components/autoReplies/autoReplies.template.html';
        controller = AutoRepliesContoller;
        controllerAs = 'autoRep';
        bindings: any = {
            replies: '=',
            isEditingMessaging: '=',
            charLimit: '<?'
        };
    }

    angular.module('meevo.plugins.meevoMessengerSettings')
        .component('meevoMessengerSettingsAutoReplies', new AutoRepliesComponent());

}

